import PixelObject from './PixelObject'
import Rose from './modifiers/rose';
import Lissajous from './modifiers/lissajous';

import { QuadTreePoint, Rectangle } from './QuadTreePoint'

export default class Quad extends PixelObject {
    constructor(options) {
        super(options);

        const defaults = {
            type: 'QUAD',
            name: 'Quad',
            noise: 25,
            limit: 1,
            width: this.ctx.width,
            height: this.ctx.height,
            modifiers: [new Rose({ parent: this })],
        }

        let opts = { ...defaults, ...options }

        this.type = opts.type
        this.name = opts.name
        this.noise = opts.noise
        this.limit = opts.limit
        this.width = opts.width
        this.height = opts.height
        this.image = opts.image
        this.stop = opts.stop

        this.modifiers = opts.modifiers

        this.createBuffer()
    }

    set(key, newValue) {
        let config = {
            noise: (data) => { return data.newValue },
            limit: (data) => { return data.newValue },
        }

        if (config[key]) {
            const oldValue = this[key]
            let parsedValue = config[key]({ newValue, oldValue })
            if (oldValue != parsedValue) {
                this[key] = parsedValue
                this.dispatch('objectStateChanged', this.propertyChangedMessage(key))
            }
        } else {
            PixelObject.prototype.set.call(this, key, newValue)
        }
    }

    copy() {
        return new Quad(this)
    }

    renderBuffer() {
        const self = this

        console.log("Quad regenerating")

        let boundary = new Rectangle(this.width / 2, this.height / 2, this.width / 2, this.height / 2);
        this.quadTree = new QuadTreePoint(boundary, this.limit)

        for (let count = 0; count < this.noise; count++) {
            const element = {
                x: 0,
                y: 0,
                ctx: this.buffer
            };
            this.modifiers.forEach(modifier => {
                modifier.apply({ element, count, width: self.width, height: self.height })
            })

            this.quadTree.insert(element);
        }
        this.buffer.clear()
        this.stop = false
    }

    draw() {
        if (this.visible == '0' || this.deleted) return
        this.ctx.push()

        if (this.quadTree && !this.stop) {
            this.stop = true
            this.quadTree.show(this.buffer, this.getActiveChildren(), true);
            this.image = this.buffer.createImage(this.ctx.width, this.ctx.height)
            this.image.copy(this.buffer, 0, 0, this.ctx.width, this.ctx.height, 0, 0, this.ctx.width, this.ctx.height)
        }

        if (this.image) {
            this.position()
            this.ctx.translate(-this.width / 2, -this.height / 2)
            if (this.opacity !== 100) {
                this.ctx.tint(255, 255 / 100 * this.opacity)
            }
            this.ctx.image(this.image, 0, 0);
        }

        this.ctx.pop()
    }
}